import React from 'react';

const tune = () => (
  <svg width="18" height="19" viewBox="0 0 18 19" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        d="M0 14.3638V16.3638H6V14.3638H0ZM0 2.36377V4.36377H10V2.36377H0ZM10 18.3638V16.3638H18V14.3638H10V12.3638H8V18.3638H10ZM4 6.36377V8.36377H0V10.3638H4V12.3638H6V6.36377H4ZM18 10.3638V8.36377H8V10.3638H18ZM12 6.36377H14V4.36377H18V2.36377H14V0.36377H12V6.36377Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path d="M0 0.36377H18V18.3638H0V0.36377Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default tune;
